// Backend address. Set REACT_APP_API_URL in .env.local (or the build environment) to point elsewhere.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
